exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-section-components{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex}.header-section-components .col{-webkit-box-flex:1;-ms-flex:1;flex:1}.header-section-components .col.col-button{text-align:right}.header-section-components .title-page-destaq{font-weight:600;font-size:18px;color:#000}.header-section-components .btn-action-right{background-color:#023874;border-radius:10px;padding:0 30px;color:#fff;height:40px;font-size:14px;line-height:40px}.header-section-components .btn-action-right.second{background-color:#0079ba}", ""]);

// exports
